import Vue from "vue";

const vuemoment = require('vue-moment')
const moment = require('moment-timezone')
const { APP_TIMEZONE } = require('../common/util/date-time')
moment.tz.setDefault(APP_TIMEZONE)
require('moment/locale/pt-br')
 
Vue.use(vuemoment, {
  moment
})